module.exports = __webpack_public_path__ + "img/cakeboard.a4080982.png";